import { render } from "./InvoiceList.vue?vue&type=template&id=5b2dfafc&scoped=true&ts=true"
import script from "./InvoiceList.vue?vue&type=script&lang=ts"
export * from "./InvoiceList.vue?vue&type=script&lang=ts"

import "./InvoiceList.vue?vue&type=style&index=0&id=5b2dfafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2dfafc"]])

export default __exports__